import React from 'react';
import { MdManageAccounts } from "react-icons/md";
import './StatusIndicator.scss'; // Ensure the SASS file is imported

const StatusIndicator = () => {
  return (
    <div className="status-indicator">
      <div className="status-group">
        <MdManageAccounts className='i' /> {/* Icon component */}
        <span className="status-title">Task title</span>
      </div>
      <span className="status-stats">Success rate 39 | 89.74%</span>
    </div>
  );
};

export default StatusIndicator;
